export default __webpack_public_path__ + "static/media/fya-text-logo.2a6754b2.svg";